import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://connect.bybloomlabs.com";

export function Seo({ title, description, path = "/", noindex = false, image, jsonLd }) {
  const fullTitle = title ? `${title} | BloomCONNECT` : "BloomCONNECT \u2014 The AI sales agent for your inbox";
  const canonical = SITE + (path.endsWith("/") || path.includes("?") ? path : path + "/");
  const og = image || `${SITE}/og/default.png`;
  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || ""} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || ""} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={og} />
      <meta property="og:site_name" content="BloomCONNECT" />
      <meta name="twitter:card" content="summary_large_image" />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
}

export const orgJsonLd = () => ({
  "@context": "https://schema.org", "@type": "Organization", name: "BloomCONNECT",
  url: SITE, legalName: "Bloom DevLabs Corp.",
  contactPoint: { "@type": "ContactPoint", email: "connect.support@bybloomlabs.com", contactType: "customer support" },
});
export const websiteJsonLd = () => ({
  "@context": "https://schema.org", "@type": "WebSite", name: "BloomCONNECT", url: SITE,
  potentialAction: { "@type": "SearchAction", target: `${SITE}/resources/?q={q}`, "query-input": "required name=q" },
});
export const faqJsonLd = (items) => ({
  "@context": "https://schema.org", "@type": "FAQPage",
  mainEntity: (items || []).map((f) => ({ "@type": "Question", name: f.q || f.question,
    acceptedAnswer: { "@type": "Answer", text: f.a || f.answer } })),
});
export const breadcrumbJsonLd = (crumbs) => ({
  "@context": "https://schema.org", "@type": "BreadcrumbList",
  itemListElement: crumbs.map((c, i) => ({ "@type": "ListItem", position: i + 1, name: c.name, item: SITE + c.path })),
});
export const articleJsonLd = (p) => ({
  "@context": "https://schema.org", "@type": "Article", headline: p.title,
  description: p.description, author: { "@type": "Organization", name: p.author || "BloomCONNECT" },
  datePublished: p.updated, dateModified: p.updated,
});
export const itemListJsonLd = (items) => ({
  "@context": "https://schema.org", "@type": "ItemList",
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it })),
});
